import { createRouter, createWebHashHistory } from 'vue-router'
//import HomeView from '../views/HomeView.vue'
import isAuthenticatedGuard from '../modules/auth/router/auth-guard'

import daybookRouter from '../modules/daybook/router'
import sclmRouter from '../modules/sclm/router'
import authRouter from '../modules/auth/router'

const routes = [
  {
    path: '/',
    //...authRouter
    name: 'auth',
    beforeEnter: [ isAuthenticatedGuard ],
    ...daybookRouter
    //component: () => import(/* webpackChunkName: "login" */ '../modules/auth/views/Login.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/auth',
    ...authRouter
    //component: () => import(/* webpackChunkName: "daybook" */ '../modules/daybook/layouts/DayBookLayout.vue')
  },
  {
    path: '/daybook',
    beforeEnter: [ isAuthenticatedGuard ],
    ...daybookRouter
    //component: () => import(/* webpackChunkName: "daybook" */ '../modules/daybook/layouts/DayBookLayout.vue')
  },
  {
    path: '/scml',
    ...sclmRouter
    //component: () => import(/* webpackChunkName: "sclm" */ '@/modules/sclm/views/SclmApp.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
